<template>
  <v-combobox
    label="Professional Tools"
    v-model="profile.professionalTools"
    :color="themes.candidate.light.input"
    :loading="loading"
    append-icon=""
    :items="[]"
    @blur="submit"
    multiple
  >
    <template slot="selection" slot-scope="{ item, selected, parent }">
      <v-chip
        @input="parent.onChipInput"
        :key="`technical-competency-${item}`"
        :color="themes.candidate.light.chip"
        :selected="selected"
      >
        {{ item }}
        <v-icon right :color="themes.candidate.light.cancel" @click="parent.selectItem(item)">
          mdi-close-circle
        </v-icon>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    value: Array,
  },
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        professionalTools: this.value || [],
      },
    }
  },
  methods: {
    submit() {
      if (this.value !== this.profile.professionalTools) {
        this.loading = true
        this.$store
          .dispatch('candidate/profile/update', this.profile)
          .finally(() => (this.loading = false))
      }
    },
  },
}
</script>
